export default {
    projectKey: "Project Key",
    updatedBy: "Updated By",
    entityName: "Entity Name",
    entityId: "Entity Id",
    preferenceKey: "Preference Key",
    updatedOn: "Updated On",
    deviceId: "Device Id",
    temperature3: "Temperature 3",
    temperature1: "Temperature 1",
    temperature2: "Temperature 2",
    eventName: "Event Name",
    vin: "Vin",
    serverTime: "Server Time",
    longitude: "Longitude",
    sequenceNumber: "Sequence Number",
    normalizedSpeed: "Normalized Speed",
    desiredStarterState: "Desired Starter State",
    speedLimit: "Speed Limit",
    accountId: "Account Id",
    republish: "Republish",
    driverId: "Driver Id",
    LastMessageTime: "Last Message Time",
    region: "Region",
    useEcuSpeed: "Use Ecu Speed",
    useEcuOcometer: "Use Ecu Ocometer",
    distance: "Distance",
    latitude: "Latitude",
    deviceLabel: "Device Label",
    ecuEngineOdometer: "Ecu Engine Odometer",
    rawMessage: "Raw Message",
    starterDisabled: "Starter Disabled",
    unitType: "Unit Type",
    ignitionStatus: "Ignition Status",
    satelliteCount: "Satellite Count",
    unitId: "Unit Id",
    starterSupported: "Starter Supported",
    unitgroupname: "Unit Group Name",
    unitgroup_id: "Unit Group Id",
    unitgroupcolor: "Unit Group Color",
    zip: "Zip",
    address: "Address",
    state: "State",
    city: "City",
    formatted: "Formatted",
    messageSource: "Message Source",
    datacenter: "Data Center",
    rowId: "Row Id",
    eventCode: "Event Code",
    unitDiagnostic: "Unit Diagnostic",
    desiredStarterUpdated: "Desired Starter Updated",
    unitTime: "Unit Time",
    configJSON: "Config JSON",
    severity: "Severity",
    assignmentsCount: "Assignments Count",
    subscribersCount: "Subscribers Count",
    type: "Type",
    createdOn: "Created On",
    triggerCount: "Trigger Count",
    createdBy: "Created By",
    name: "Name",
    currentTab: "Current Tab",
    defaultDateInfo: "Default Date Info",
    companyId: "Company Id",
    fileIndex: "File Index",
    generatedAt: "Generated At",
    jsonPath: "Json Path",
    changedAt: "Changed At",
    generatedFile: "Generated File",
    alertBefore: "Alert Before",
    contactId: "Contact Id",
    alert: "Alert",
    alertAfter: "Alert After",
    lastMaintenanceDate: "Last Maintenance Date",
    notes: "Notes",
    completed: "Completed",
    estimatedCost: "Estimated Cost",
    lastMaintenanceOdometer: "Last Maintenance Odometer",
    nextServiceDate: "Next Service Date",
    fileIds: "File Ids",
    unitLabel: "Unit Label",
    serviceId: "Service Id",
    status: "Status",
    isGrouping: "Is Grouping",
    year: "Year",
    ecuVin: "Ecu Vin",
    model: "Model",
    landmark_id: "Landmark Id",
    driverName: "Driver Name",
    deviceNote: "Device Note",
    sourceStack: "Source Stack",
    landmarkname: "Landmark Name",
    make: "Make",
    landmarkgroup_id: "Landmark Group Id",
    placeId: "Place Id",
    landmarkName: "Landmark Name",
    change_details_title: "Change",
    projectId: "Project",
    description: "Description",
    crmId: "Salesforce Id",
    Timezone: "Time Zone",
    roleId: "Role Id",
    language: "Language",
    res: "Result",
    method: "Method",
    action: "Action",
    username: "Username",
    source: "Source",
    module: "Module",
    platform: "Platform",
    ipAddress: "Ip Address",
    moduleId: "Module Id",
    isDefault: "Is Default",
    isCustom: "Is Custom",
    tripID: "Trip ID",
    notificationType: "Notification Type",
    linkedDeviceId: "Paired Device Id",
    troubleshooting: "Troubleshooting",
    changeTime: "Change Time",
    accumulatedDistance: "Accumulated Distance",
    currentStatus: "Current Status",
    sn: "SN",
    vehicleID: "Vehicle ID",
    previousStatus: "Previous Status",
    url: "Url",
    units: "Units",
    iot_rule_source: "IOT Rule Source",
    address: "Address",
    deviceData: "Device Data",
    rawMessage: "Raw Message",
    speedLimitRequest: "Speed Limit Request",

    field: "Field",
    parentId: "Parent Id",
    categoryName: "Category Name",
    dataResultFilter: "Data Result Filter",
    timeframeName: "Time Frame Name",
    timeZone: "Time Zone",
    order: "Order",
    fileFormat: "File Format",
    orientation: "Orientation",
    column: "Column",
    header: "Header",
    folderName: "Folder Name",
    filePrefixName: "File Prefix Name",
    culture: "Culture",
    sendByEmail: "Send By Email",
    reportName: "Report Name",
    UIParams: "UI Params",
    delayed: "Delayed",
    code: "Code",

    clipID: "Clip ID",
    createdByUser: "Created By User",
    startDate: "Start Date",
    thumbnailUrl: "Thumbnail Url",
    endDate: "End Date",
    transactionId: "Transaction Id",
    errorMsg: "Error Message",
    gpsTime: "GPS Time",
    authId: "Auth Id",
    driver: "Driver",
    compdata: "Comp Data",
    unit: "Unit",
    data: "Data",
    distanceInMile: "Distance In Mile",
    warningCode: "Warning Code"
};
